import {useCallback, useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';

import { getPath } from '../../utils/api';

import './Pathway.css';

function Pathway({ activityId, handleError }) {
  const ACTIVITY_CLASSES = ['right', 'left'];
  const navigate = useNavigate();

  const [activities, setActivities] = useState(null);

  const getActivities = useCallback(async () => {
    try {
      setActivities(await getPath());
    } catch (e) {
      handleError(e);
    }
  }, [handleError]);

  const handleActivity = useCallback((id) => {
    navigate('/activity/' + id);
  }, [navigate]);

  useEffect(() => {
    getActivities();
  }, [getActivities]);

  return (
    <div id="pathway">
      <div className="pathway">
        {activities?.length ? activities.map((activity, activityIndex) => {
          return (
            <div key={activityIndex} className={'activity-container ' + (activityIndex === activities.length - 1 ? 'center' : ACTIVITY_CLASSES[activityIndex % ACTIVITY_CLASSES.length]) + ' ' + (activity.type || 'career') + (activity._id === activityId ? ' active' : '') + (activity.status === 'completed' ? ' completed' : '')} onClick={() => handleActivity(activity._id)}>
              <div className="activity-connection"></div>
              <div className="activity-connector"></div>
              <div className="activity" title={activity.title}>
                <div className="activity-inner"></div>
              </div>
              <div className="activity-title">{activity.title}</div>
            </div>
          );
        }) : null}
      </div>
    </div>
  );
}

export default Pathway;
